import { Paragraph2, UIHeading2, UIHeading4 } from '@cian/ui-kit/typography';
import * as React from 'react';

import styles from './CommercialMultiAdsTitle.css';
import { GeneralInfoSectionRow } from '../../GeneralInfoSectionRow';

interface ICommercialMultiAdsTitleProps {
  title?: string;
  subtitle?: string;
  availability?: string;
  href: string;
  rel?: string;
}

export const CommercialMultiAdsTitleComponent: React.FC<ICommercialMultiAdsTitleProps> = ({
  title,
  subtitle,
  availability,
  href,
  rel = 'noreferrer',
}) => {
  const target = rel?.includes('noreferrer') ? '_blank' : undefined;

  return (
    <GeneralInfoSectionRow>
      <a className={styles['link']} href={href} target={target} rel={rel} data-name="CommercialMultiAdsTitleComponent">
        {title ? (
          <>
            <UIHeading2 data-mark="CommercialMultiAdsTitle" color="accent-main-primary">
              {title}
            </UIHeading2>
            {subtitle && (
              <div className={styles['subtitle']}>
                <UIHeading4 data-mark="CommercialMultiAdsSubtitle" color="text-primary-default">
                  {subtitle}
                </UIHeading4>
              </div>
            )}
          </>
        ) : (
          subtitle && (
            <UIHeading2 data-mark="CommercialMultiAdsSubtitle" color="text-primary-default">
              {subtitle}
            </UIHeading2>
          )
        )}
        {availability && (
          <div className={styles['availability']}>
            <Paragraph2 data-mark="CommercialMultiAdsAvailability" color="text-primary-default">
              {availability}
            </Paragraph2>
          </div>
        )}
      </a>
    </GeneralInfoSectionRow>
  );
};

CommercialMultiAdsTitleComponent.displayName = 'CommercialMultiAdsTitle';

export const CommercialMultiAdsTitle = React.memo(CommercialMultiAdsTitleComponent);
